import React from 'react';
import PropTypes from 'prop-types';
import {
    isEmpty as _isEmpty,
} from 'lodash';

import {AppliedPreset} from '@modules/events/components/EventsTabsLayout/Details/EventDetails/column1/AppliedPreset';
import {EventId} from '@modules/events/components/EventsTabsLayout/Details/EventDetails/column1/EventId';
import {PropertyLicence} from '@modules/events/components/EventsTabsLayout/Details/EventDetails/column1/PropertyLicence';
import {
    CoverageWithClipProviders,
} from '@modules/events/components/EventsTabsLayout/Details/EventDetails/column1/CoverageWithClipProviders';

export const getFieldsList = (event) => {
    let fieldsColumn = [
        {
            name: 'ID',
            value: <EventId event={event}/>,
        },
        {
            name: 'Type',
            value: event.event_type.name,
        },
        {
            name: 'Property licence',
            value: <PropertyLicence event={event}/>,
        },
        {
            name: 'Applied preset',
            value: <AppliedPreset event={event}/>,
        },
    ];

    if (!_isEmpty(event.products)) {
        fieldsColumn.push(
            {
                name: 'Coverage',
                value: <CoverageWithClipProviders products={event.products} clip_providers={event.clip_providers} />,
            }
        );
    }

    return fieldsColumn;
};

getFieldsList.propTypes = {
    event: PropTypes.shape({
        event_type: PropTypes.shape({
            name: PropTypes.string,
        }),
        clip_providers: PropTypes.arrayOf(
            PropTypes.shape({
                clip_provider: PropTypes.shape({
                    id: PropTypes.string,
                    name: PropTypes.string,
                }),
            })
        ),
    }).isRequired,
};

getFieldsList.defaultProps = {
    event: {
        event_type: {
            name: null,
        },
    },
};
